var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationFilled = function SvgLocationFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1a5.507 5.507 0 0 0-5.5 5.5 5.444 5.444 0 0 0 1.108 3.3s.15.197.174.226L8 15l4.22-4.976c.022-.027.172-.224.172-.224v-.001A5.442 5.442 0 0 0 13.5 6.5 5.507 5.507 0 0 0 8 1Zm0 7.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
    fill: "#E8114D"
  })));
};
export default SvgLocationFilled;